const abnValidationWeightings = [
  10,
  1,
  3,
  5,
  7,
  9,
  11,
  13,
  15,
  17,
  19
]

export const ABN_LENGTH = 11

// validateAbn returns true if the provided ABN is valid.
// https://abr.business.gov.au/Help/AbnFormat
export function validateAbn (val) {
  const abn = val || ''
  // eslint-disable-next-line eqeqeq
  const digits = abn.split('').filter(v => v == parseInt(v)).map(Number)
  if (digits.length !== abnValidationWeightings.length) return false
  digits[0]--
  const sum = digits
    .map((v, i) => v * abnValidationWeightings[i])
    .reduce((t, v) => t + v, 0)
  return sum % 89 === 0
}

export function cleanAbn (val) {
  return (val || '')
    .split('')
  // eslint-disable-next-line eqeqeq
    .filter(v => v == parseInt(v))
    .join('')
}
